// import React, { useState, useEffect } from "react";
// import images from "../../../images.config";
// import icons from "../../../icons.config";
// import {
//   createCustomSize,
//   fetchAllCustomSizes,
//   updateCustomSize,
//   deleteCustomSize,
// } from "../../../Providers/customSizeProvider";
// import { useDispatch, useSelector } from "react-redux";

// const dummyImages = [
//   images.collection1,
//   images.collection2,
//   images.collection3,
//   images.collection1,
//   images.collection2,
//   images.collection3,
// ];

// const CustomSizeModal = ({ onClose }) => {
//   const dispatch = useDispatch();
//   const [unit, setUnit] = useState("inches");
//   const [measurements, setMeasurements] = useState({});
//   const [image, setImage] = useState(dummyImages[0]);
//   const [loading, setLoading] = useState(false);
//   const [showForm, setShowForm] = useState(false);
//   const [editingSizeId, setEditingSizeId] = useState(null);

//   const { sizes = [] } = useSelector((state) => state.customSize);

//   const measurementFields = [
//     { name: "chest_measure", label: "Chest" },
//     { name: "high_waist_measure", label: "High Waist" },
//     { name: "mid_waist_measure", label: "Mid Waist" },
//     { name: "hip_means_measure", label: "Hip" },
//     { name: "maxi_length_measure", label: "Maxi Length" },
//     { name: "mini_length_measure", label: "Mini Length" },
//   ];

//   useEffect(() => {
//     dispatch(fetchAllCustomSizes());
//   }, [dispatch]);

//   const handleInputChange = (e, index) => {
//     const { name, value } = e.target;
//     if (!/^\d*$/.test(value)) return;
//     setMeasurements((prev) => ({ ...prev, [name]: value }));
//     setImage(dummyImages[index]);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const missingFields = measurementFields.filter(
//       (field) => !measurements[field.name]?.trim()
//     );

//     if (missingFields.length > 0) {
//       alert(
//         `Please fill all fields! Missing: ${missingFields
//           .map((f) => f.label)
//           .join(", ")}`
//       );
//       return;
//     }

//     setLoading(true);

//     try {
//       const payload = { unit, ...measurements };

//       if (editingSizeId) {
//         await dispatch(updateCustomSize({ _id: editingSizeId, ...payload })).unwrap();
//         alert("✅ Measurements updated successfully!");
//       } else {
//         await dispatch(createCustomSize(payload)).unwrap();
//         alert("✅ Measurements submitted successfully!");
//       }

//       dispatch(fetchAllCustomSizes());
//       setMeasurements({});
//       setShowForm(false);
//       setEditingSizeId(null);
//     } catch (error) {
//       alert(`❌ Submission failed: ${error.response?.data?.message || error.message || "Try again later."}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDelete = async (_id) => {
//     if (window.confirm("Are you sure you want to delete this size?")) {
//       try {
//         await dispatch(deleteCustomSize(_id)).unwrap();
//         alert("✅ Size deleted successfully!");
//         dispatch(fetchAllCustomSizes());
//       } catch (error) {
//         alert(`❌ Deletion failed: ${error.response?.data?.message || error.message || "Try again later."}`);
//       }
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//       <div className="bg-white rounded-lg w-full max-w-2xl lg:max-w-[60%] h-auto px-6 py-8 shadow-xl relative">
//         <h2 className="text-center text-primary1 text-2xl font-semibold mb-4">
//           Custom Size
//         </h2>

//         <button
//           onClick={onClose}
//           className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
//         >
//           <img src={icons.close} alt="Close" className="w-6 h-6" />
//         </button>
//         <hr className="border-gray-300 mb-4" />

//         {/* Saved Sizes Section */}
//         {sizes.length > 0 && !showForm && (
//           <div>
//             <h3 className="text-lg font-semibold">Saved Sizes</h3>
//             <ul className="space-y-2">
//               {sizes.map((size, index) => (
//                 <li
//                   key={size._id}
//                   className="p-2 border border-gray-300 rounded-md flex justify-between items-center"
//                 >
//                   <span>{`Size ${index + 1}`}</span>
//                   <div className="flex space-x-3">
//                     <button
//                       onClick={() => {
//                         setMeasurements(size);
//                         setUnit(size.unit);
//                         setEditingSizeId(size._id);
//                         setShowForm(true);
//                       }}
//                       className="text-blue-600 hover:text-blue-800"
//                     >
//                       ✎ Edit
//                     </button>
//                     <button
//                       onClick={() => handleDelete(size._id)}
//                       className="text-red-600 hover:text-red-800"
//                     >
//                       🗑 Delete
//                     </button>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         )}

//         {/* Add New Custom Size Button */}
//         {(!sizes.length || showForm) && (
//           <button
//             onClick={() => {
//               setShowForm(true);
//               setMeasurements({});
//               setEditingSizeId(null);
//             }}
//             className="flex items-center justify-center w-full mt-4 p-2 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-100 transition"
//           >
//             + Add New Custom Size
//           </button>
//         )}

//         {/* Custom Size Form */}
//         {showForm && (
//           <div className="flex flex-col lg:flex-row mt-4">
//             <div className="w-full lg:w-1/2 flex justify-center items-center mb-4 lg:mb-0 px-2">
//               <img
//                 src={image}
//                 alt="Measurement Guide"
//                 className="w-full max-w-[200px] md:max-w-[70%] rounded-md shadow-md"
//               />
//             </div>

//             <div className="lg:w-1/2 space-y-5">
//               <h3 className="text-lg font-semibold">Choose your units:</h3>
//               <div className="flex space-x-4 mb-4">
//                 {["inches", "cm"].map((u) => (
//                   <label key={u} className="flex items-center text-sm">
//                     <input
//                       type="radio"
//                       name="unit"
//                       value={u}
//                       checked={unit === u}
//                       onChange={() => setUnit(u)}
//                       className="mr-2"
//                     />
//                     {u.toUpperCase()}
//                   </label>
//                 ))}
//               </div>

//               <form onSubmit={handleSubmit} className="space-y-6">
//                 <div className="grid grid-cols-2 gap-4">
//                   {measurementFields.map((field, index) => (
//                     <div key={index} className="flex flex-col">
//                       <label className="text-sm font-medium">{field.label}</label>
//                       <input
//                         type="text"
//                         name={field.name}
//                         value={measurements[field.name] || ""}
//                         placeholder={`Enter ${field.label}`}
//                         className="p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary"
//                         onChange={(e) => handleInputChange(e, index)}
//                       />
//                     </div>
//                   ))}
//                 </div>

//                 <button
//                   type="submit"
//                   className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"
//                   disabled={loading}
//                 >
//                   {loading ? "Submitting..." : editingSizeId !== null ? "UPDATE" : "SUBMIT"}
//                 </button>
//               </form>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CustomSizeModal;

// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchAllCustomSizes, createCustomSize, updateCustomSize, deleteCustomSize } from "../../../Providers/customSizeProvider";
// import images from "../../../images.config";
// import icons from "../../../icons.config";

// const dummyImages = [images.collection1, images.collection2, images.collection3];

// const CustomSizeModal = ({ onClose }) => {
//   const dispatch = useDispatch();
//   const { sizes=[], loading } = useSelector((state) => state.customSize);
//   const [unit, setUnit] = useState("inches");
//   const [measurements, setMeasurements] = useState({});
//   const [image, setImage] = useState(dummyImages[0]);
//   const [isAdding, setIsAdding] = useState(false);

//   useEffect(() => {
//     dispatch(fetchAllCustomSizes());
//   }, [dispatch]);

//   const handleInputChange = (e, index) => {
//     const { name, value } = e.target;
//     if (!/^\d*$/.test(value)) return;
//     setMeasurements((prev) => ({ ...prev, [name]: value }));
//     setImage(dummyImages[index]);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (Object.values(measurements).some((val) => !val?.trim())) {
//       alert("Please fill all fields!");
//       return;
//     }
//     const payload = { unit, ...measurements };
//     await dispatch(createCustomSize(payload));
//     setIsAdding(false);
//   };

// const handleDelete = async (id) => {
//   if (window.confirm("Are you sure you want to delete this size?")) {
//     await dispatch(deleteCustomSize(id));
//   }
// };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 top-16 lg:top-24">
//       <div className="bg-white rounded-lg w-full max-w-lg md:max-w-2xl lg:max-w-[60%] h-auto px-6 py-8">
//         <h2 className="text-center text-xl font-bold mb-4">Custom Size</h2>

//         <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
//           <img src={icons.close} alt="close icon" />
//         </button>

//         {loading ? (
//           <p className="text-center">Loading sizes...</p>
//         ) : sizes.length > 0 && !isAdding ? (
//           <div>
//             <h3 className="text-lg font-semibold mb-2">Saved Sizes</h3>
//             {sizes.map((size, index) => (
//               <div key={size.id} className="flex justify-between items-center border p-2 mb-2">
//                 <span>Size {index + 1}</span>
//                 <div>
//                   <button className="text-blue-500 mr-2" onClick={() => setIsAdding(true)}>Edit</button>
//                   <button className="text-red-500" onClick={() => handleDelete(size.id)}>Delete</button>
//                 </div>
//               </div>
//             ))}
//             <button className="flex items-center text-blue-500 mt-4" onClick={() => setIsAdding(true)}>
//               + Add New Custom Size
//             </button>
//           </div>
//         ) : (
//           <form onSubmit={handleSubmit}>
//             <label>Unit:</label>
//             <select value={unit} onChange={(e) => setUnit(e.target.value)}>
//               <option value="inches">Inches</option>
//               <option value="cm">CM</option>
//             </select>
//             <input type="text" name="chest_measure" onChange={handleInputChange} />
//             <button type="submit">Submit</button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CustomSizeModal;

// import React, { useState, useEffect } from "react";
// import images from "../../../images.config";
// import icons from "../../../icons.config";
// import { createCustomSize, fetchAllCustomSizes, updateCustomSize } from "../../../Providers/customSizeProvider";
// import { useDispatch, useSelector } from "react-redux";

// const dummyImages = [
//   images.collection1,
//   images.collection2,
//   images.collection3,
//   images.collection1,
//   images.collection2,
//   images.collection3,
// ];

// const CustomSizeModal = ({ onClose, selectedSize }) => {
//   const dispatch = useDispatch();
//   const [unit, setUnit] = useState("inches");
//   const [measurements, setMeasurements] = useState({});
//   const [image, setImage] = useState(dummyImages[0]);
//   const [loading, setLoading] = useState(false);
//   const [saveMeasurements, setSaveMeasurements] = useState(false);
//   const { sizes = [] } = useSelector((state) => state.customSize);

//   const measurementFields = [
//     { name: "chest_measure", label: "Chest" },
//     { name: "high_waist_measure", label: "High Waist" },
//     { name: "mid_waist_measure", label: "Mid Waist" },
//     { name: "hip_means_measure", label: "Hip" },
//     { name: "maxi_length_measure", label: "Maxi Length" },
//     { name: "mini_length_measure", label: "Mini Length" },
//   ];

//   useEffect(() => {
//     dispatch(fetchAllCustomSizes());
//   }, [dispatch]);

//   useEffect(() => {
//     if (selectedSize) {
//       setUnit(selectedSize.unit);
//       setMeasurements(selectedSize);
//     } else {
//       const savedData = localStorage.getItem("savedMeasurements");
//       if (savedData) {
//         setMeasurements(JSON.parse(savedData));
//       }
//     }
//   }, [selectedSize]);

//   const handleInputChange = (e, index) => {
//     const { name, value } = e.target;
//     if (!/^\d*$/.test(value)) return;
//     setMeasurements((prev) => ({ ...prev, [name]: value }));
//     setImage(dummyImages[index]);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const missingFields = measurementFields.filter(field => !measurements[field.name]?.trim());

//     if (missingFields.length > 0) {
//       alert(`Please fill all fields! Missing: ${missingFields.map(f => f.label).join(", ")}`);
//       return;
//     }

//     setLoading(true);

//     try {
//       const payload = { unit, ...measurements };

//       if (saveMeasurements) {
//         localStorage.setItem("savedMeasurements", JSON.stringify(measurements));
//       } else {
//         localStorage.removeItem("savedMeasurements");
//       }

//       let response;
//       if (selectedSize) {
//         response = await dispatch(updateCustomSize({ id: selectedSize.id, ...payload })).unwrap();
//         alert("✅ Measurements updated successfully!");
//       } else {
//         response = await dispatch(createCustomSize(payload)).unwrap();
//         alert("✅ Measurements submitted successfully!");
//       }

//       setMeasurements({});
//       onClose();
//     } catch (error) {
//       alert(`❌ Submission failed: ${error.message || "Try again later."}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//       <div className="bg-white rounded-lg w-full max-w-2xl lg:max-w-[60%] h-auto px-6 py-8 shadow-xl relative">
//         <h2 className="text-center text-primary1 text-2xl font-semibold mb-4">Custom Size</h2>

//         <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
//           <img src={icons.close} alt="Close" className="w-6 h-6" />
//         </button>
//         <hr className="border-gray-300 mb-4" />

//         <div className="flex flex-col lg:flex-row">
//           <div className="w-full lg:w-1/2 flex justify-center items-center mb-4 lg:mb-0 px-2">
//             <img src={image} alt="Measurement Guide" className="w-full max-w-[200px] md:max-w-[70%] rounded-md shadow-md" />
//           </div>

//           <div className="lg:w-1/2 space-y-5">
//             <h3 className="text-lg font-semibold">Choose your units:</h3>
//             <div className="flex space-x-4 mb-4">
//               {["inches", "cm"].map((u) => (
//                 <label key={u} className="flex items-center text-sm">
//                   <input
//                     type="radio"
//                     name="unit"
//                     value={u}
//                     checked={unit === u}
//                     onChange={() => setUnit(u)}
//                     className="mr-2"
//                   />
//                   {u.toUpperCase()}
//                 </label>
//               ))}
//             </div>

//             <form onSubmit={handleSubmit} className="space-y-6">
//               <div className="grid grid-cols-2 gap-4">
//                 {measurementFields.map((field, index) => (
//                   <div key={index} className="flex flex-col">
//                     <label className="text-sm font-medium">{field.label}</label>
//                     <input
//                       type="text"
//                       name={field.name}
//                       value={measurements[field.name] || ""}
//                       placeholder={`Enter ${field.label}`}
//                       className="p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary"
//                       onChange={(e) => handleInputChange(e, index)}
//                     />
//                   </div>
//                 ))}
//               </div>

//               <div className="flex items-center space-x-2">
//                 <input
//                   type="checkbox"
//                   id="saveMeasurements"
//                   checked={saveMeasurements}
//                   onChange={(e) => setSaveMeasurements(e.target.checked)}
//                   className="w-4 h-4 text-blue-500 border-gray-300 focus:ring-blue-400"
//                 />
//                 <label htmlFor="saveMeasurements" className="text-sm">Save measurements for next time</label>
//               </div>

//               <button
//                 type="submit"
//                 className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"
//                 disabled={loading}
//               >
//                 {loading ? "Submitting..." : selectedSize ? "UPDATE" : "SUBMIT"}
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CustomSizeModal;
import React, { useState, useEffect,useRef } from "react";
import images from "../../../images.config";
import icons from "../../../icons.config";
import {
  createCustomSize,
  fetchAllCustomSizes,
  updateCustomSize,
  deleteCustomSize,
} from "../../../Providers/customSizeProvider";
import { useDispatch, useSelector } from "react-redux";
import { setCustomSizeId as setCustomSizeIdRedux } from "../../../Providers/customSizeProvider";
import SizeAddedPopup from "./sizeAddedPopup";
import DeleteSizePopup from "./deleteSizePopUp";


const dummyImages = [
  icons.chestMeasure,
  icons.highWaistMeasure,
  icons.midWaistMeasure,
  icons.hipMeasure,
  icons.lengthMeasure,
  icons.howToMeasure,
];

const CustomSizeModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const [unit, setUnit] = useState("inches");
  const [measurements, setMeasurements] = useState({});
  const [image, setImage] = useState(dummyImages[0]);
  const [loading, setLoading] = useState(false);
  const [editingSizeId, setEditingSizeId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [title, setTitle] = useState(""); // Step 1: Add title state
  // const [ customSizeId,setCustomSizeId] = useState("");
  const [sizeAddedPopUp,setSizeAddedPopUp]=useState(false);
  useEffect(() => {
    if (!showForm) {
      dispatch(fetchAllCustomSizes());
    }
  }, [dispatch, showForm]);

  const sizes = useSelector((state) => state.customSize.sizes) || [];
  console.log("sizes is the -------------", sizes);

  const measurementFields = [
    { name: "chest_measure", label: "Chest" },
    { name: "high_waist_measure", label: "High Waist" },
    { name: "mid_waist_measure", label: "Mid Waist" },
    { name: "hip_means_measure", label: "Hip" },
    { name: "maxi_length_measure", label: "Maxi Length" },
    { name: "mini_length_measure", label: "Mini Length" },
  ];

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    if (!/^\d*$/.test(value)) return;
    setMeasurements((prev) => ({ ...prev, [name]: value }));
    setImage(dummyImages[index]);
  };
  // const saveCustomSizeId = (value)=>{
  //   console.log("custom id----",value);
  //   setCustomSizeId(value);
  // }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim()) {
      alert("Please enter a title for the custom size!");
      return;
    }

    const missingFields = measurementFields.filter(
      (field) => !measurements[field.name]?.trim()
    );
    if (missingFields.length > 0) {
      alert(
        `Please fill all fields! Missing: ${missingFields
          .map((f) => f.label)
          .join(", ")}`
      );
      return;
    }

    setLoading(true);
    try {
      const payload = { title, unit, ...measurements }; // Step 4: Include title

      if (editingSizeId) {
        await dispatch(
          updateCustomSize({ _id: editingSizeId, ...payload })
        ).unwrap();
       
setSizeAddedPopUp(true);




      } else {
        await dispatch(createCustomSize(payload)).unwrap();
       
        setSizeAddedPopUp(true);
        
        
      }

      dispatch(fetchAllCustomSizes());
      // Reset title
      setMeasurements({});
      setShowForm(false);
      setEditingSizeId(null);
    } catch (error) {
      alert(
        `❌ Submission failed: ${
          error.response?.data?.message || error.message || "Try again later."
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (_id) => {
    setSelectedSizeId(_id); // Store the selected size ID
    setShowDeletePopup(true); // Show the delete confirmation popup
  };
  
  const handleConfirmDelete = async () => {
    if (!selectedSizeId) return;
  
    try {
      await dispatch(deleteCustomSize(selectedSizeId)).unwrap();
      setShowDeletePopup(false); // Close popup after successful deletion
      dispatch(fetchAllCustomSizes());
    } catch (error) {
      alert(`❌ Deletion failed: ${error.response?.data?.message || error.message}`);
    }
  };
  
  const customSizeId = useSelector((state) => state.customSize.customSizeId); 

  const saveCustomSizeId = (value) => {
    console.log("Selected custom size ID:", value);
    
    dispatch(setCustomSizeIdRedux(value)); // Store in Redux
  };

  const [selectedSizeId, setSelectedSizeId] = useState(customSizeId || ""); // Track selected size

const handleCheckboxChange = (sizeId) => {
  setSelectedSizeId(sizeId); // Update local state
  saveCustomSizeId(sizeId); // Save in Redux
};
const [showDeletePopup, setShowDeletePopup] = useState(false);

const handleDeleteSize = () => {
  console.log("Size deleted!");
  setShowDeletePopup(false); // Close popup after deletion
};
const popupRef = useRef(null);

  useEffect(() => {
    document.body.classList.add("overflow-hidden");
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);

  useEffect(() => {
    // Function to handle click outside
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);


  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-tertiary rounded-lg w-full max-w-2xl lg:max-w-[60%] h-auto px-6 py-8 shadow-xl relative" ref={popupRef}>
        <h2 className="text-center text-primary1 text-2xl font-semibold mb-4">
          Custom Size
        </h2>

        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
        >
          <img src={icons.close} alt="Close" className="w-6 h-6" />
        </button>
        <hr className="border-secondary mb-4" />

        {/* Saved Sizes Section */}
        {/* {sizes.length>0 &&!showForm && ( */}
        {!showForm && (
          <div>
            <div>
              <h3 className="text-lg font-semibold">Saved Sizes</h3>
              <ul className="space-y-2">
  {Array.isArray(sizes) &&
    sizes.length > 0 &&
    sizes.map((size, index) => (
      <li
        key={index}
        className={`p-3 border rounded-md flex justify-between items-center cursor-pointer ${
          selectedSizeId === size._id ? " border-hcolor border-2" : "border-secondary"
        }`}
      >
        {/* Checkbox to select size */}
        <input
          type="checkbox"
          checked={selectedSizeId === size._id}
          onChange={() => handleCheckboxChange(size._id)}
          className="mr-2 accent-hcolor"
        />

        {/* Show Title of the Size */}
        <span className="font-semibold">
          {size.title || `Size ${index + 1}`}
        </span>

        <div className="flex items-center space-x-3">
          <button
            onClick={() => {
              setTitle(size.title || "");
              setMeasurements(size);
              setUnit(size.unit);
              setEditingSizeId(size._id);
              setShowForm(true);
            }}
            className="text-blue-600 hover:text-blue-800"
          >
            ✎ Edit
          </button>
          <button
            onClick={() => handleDelete(size._id)}
            className="text-red-500 hover:text-red-700"
          >
            ❌
          </button>
          {showDeletePopup && (
      <DeleteSizePopup
        onClose={() => setShowDeletePopup(false)}
        onConfirm={handleDeleteSize}
      />
    )}
        </div>
      </li>
    ))}
</ul>
            </div>
            <div className="flex" >
            <button
              onClick={() => {
                if (sizes.length > 0) {
                  fetchAllCustomSizes(); // Fetch sizes only if there are existing sizes
                }
                setShowForm(true);
                setMeasurements({});
                setEditingSizeId(null);
              }}
              className="flex items-center justify-center w-full mt-4 p-2 border border-secondary text-blue-600 rounded-md hover:bg-blue-100 transition"
            >
              + Add New Custom Size
            </button>

           
            </div>
          </div>
        )}

        {/* Add New Custom Size Button */}
        {/* {!showForm && (
          <button
            onClick={() => {
              setShowForm(true);
              setMeasurements({});
              setEditingSizeId(null);
            }}
            className="flex items-center justify-center w-full mt-4 p-2 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-100 transition"
          >
            + Add New Custom Size
          </button>
        )} */}

        {/* Custom Size Form (Shows if there are no sizes or user clicks Add New) */}
        {showForm && (
          <div className="flex flex-col lg:flex-row mt-4">
            <div className="w-full lg:w-1/2 flex justify-center items-center mb-4 lg:mb-0 px-2">
              <img
                src={image}
                alt="Measurement Guide"
                className="w-full max-w-[200px] md:max-w-[70%]  rounded-md shadow-md"
              />
            </div>

            <div className="lg:w-1/2 space-y-5">
              <h3 className="text-lg font-semibold">Choose your units:</h3>
              <div className="flex space-x-4 mb-4">
                {["inches", "cm"].map((u) => (
                  <label key={u} className="flex items-center text-sm">
                    <input
                      type="radio"
                      name="unit"
                      value={u}
                      checked={unit === u}
                      onChange={() => setUnit(u)}
                      className="mr-2"
                    />
                    {u.toUpperCase()}
                  </label>
                ))}
              </div>

              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Step 2: Add title input */}
                <div className="flex flex-col">
                  <label className="text-sm font-medium">
                    Title (For whom is this size?)
                  </label>
                  <input
                    type="text"
                    name="title"
                    value={title}
                    placeholder="Enter title (e.g., John's Custom Size)"
                    className="p-2 border border-secondary rounded-md focus:ring-2 focus:ring-primary"
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  {measurementFields.map((field, index) => (
                    <div key={index} className="flex flex-col">
                      <label className="text-sm font-medium">
                        {field.label}
                      </label>
                      <input
                        type="text"
                        name={field.name}
                        value={measurements[field.name] || ""}
                        placeholder={`Enter ${field.label}`}
                        className="p-2 border border-secondary rounded-md focus:ring-2 focus:ring-primary"
                        onChange={(e) => handleInputChange(e, index)}
                      />
                    </div>
                  ))}
                </div>

                <button
                  type="submit"
                  className="w-full bg-hcolor hover:bg-tertiary hover:text-hcolor text-tertiary border border-hcolor hover:border-hcolor py-2 rounded-md hover:bg-blue-700 transition"
                  disabled={loading}
                >
                  {loading
                    ? "Submitting..."
                    : editingSizeId !== null
                    ? "UPDATE"
                    : "SUBMIT"}
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
      {/* {showPopUp && <SizeAddedPopup onClose={() => setShowPopUp(false)} />} */}
      {sizeAddedPopUp && (
           <>
           {/* Background Overlay */}
           <div className="fixed inset-0 bg-black opacity-30 backdrop-blur-sm z-20"></div>
       
           {/* Address Submit Popup (Modal) */}
           <SizeAddedPopup onClose={() => setSizeAddedPopUp(false)} />
         </>
              )}
      

    </div>
  );
};

export default CustomSizeModal;
